import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { TemperatureResponseModel } from "./temperature.response.model";

export  class TemperatureResponse extends GlobalResponseObject {
    data?: TemperatureResponseModel[];

     /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data
     */
      

    constructor(status: boolean, errorCode: number, internalMessage: string, data?: TemperatureResponseModel[]){
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}